import { Component, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FnToasterService, FnUtilService } from 'foundation';
@Component({
  selector: 'app-eoproduct-modal',
  templateUrl: './eoproduct-modal.component.html',
  styleUrl: './eoproduct-modal.component.scss'
})
export class EOProductModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData, private dialogRef: MatDialogRef<EOProductModalComponent>, private fnutilservice: FnUtilService, private toaster: FnToasterService) {
    if (!this.fnutilservice.isEmptyObject(this.dialogData.eoProduct)) {
      this.isEdit = true;
      this.objectHash.primaryKey=this.dialogData.eoProduct.primaryKey;
      this.objectHash.name = this.dialogData.eoProduct.name;
      this.objectHash.defaultEscEmailID = this.dialogData.eoProduct.defaultEscEmailID;
    }
  }
  isEdit = false;

  objectHash = {
    primaryKey:'',
    name: '',
    defaultEscEmailID: ''
  }
    close() {
    this.dialogRef.close();
  }

  add() {
    if (this.fnutilservice.isEmptyObject(this.objectHash.name)) {
      this.toaster.error('name can not be null');
      throw new Error();
    }
    if (this.fnutilservice.isEmptyObject(this.objectHash.defaultEscEmailID)) {
      this.toaster.error('defaultEscEmailId can not be null');
      throw new Error();
    } 
    if (!this.validateEmail(this.objectHash.defaultEscEmailID)) {
      this.toaster.error('Invalid format in default EmailID');
      throw new Error('Invalid defaultEscEmailID');
    }
    this.dialogRef.close(this.objectHash);
  }

  emailRegex = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$");

  validateEmail(emailString: string): boolean {
    if (!emailString) {
      return false;
    }
    const emailArray = emailString.split(',');
    for (let i = 0; i < emailArray.length; i++) {
      const email = emailArray[i].trim();
      if (!this.emailRegex.test(email)) {
        return false;
      }
    }
    return true;
  }

  
}
interface HwDialogData {
  eoProduct: any;
}
